import {
	Component,
	Input,
	OnChanges,
	OnInit,
	EventEmitter,
	Output,
	ElementRef,
	Renderer2,
	QueryList,
	ViewChildren
} from '@angular/core';
import { PHOTO_REVIEW_UISTATE } from '../model/photo-review.constant';
import { PhotoUtilsService } from '../service/photo-review-utils.service';
import { SCHEMA_TYPE } from '../../model/quality.constant';
import { BroadcastService, BroadcastEventModel } from '@cv-invision/core';
import { GalleryOptions, ImageGallery, PhotoGalleryService } from '@cv-invision/cv.component-library.ux';

export const CREATED_RULE_EVENT = 'createdRuleEvent';

@Component({
	selector: 'cv-photo-card',
	templateUrl: './photo-card.component.html',
	styleUrls: ['./photo-card.component.scss'],
	providers: [PhotoGalleryService]
})
export class PhotoCardComponent implements OnInit, OnChanges {
	galleryOptions: GalleryOptions = {
		showCounters: false,
		hasSelected: false,
		showPreview: true,
		noFilesImage: 'assets/img/placeholder/nofiles.png',
	};

	photosCollection: Array<any>;
	cardUIState = PHOTO_REVIEW_UISTATE.CARD;
	photoCardState = PHOTO_REVIEW_UISTATE.TAB_TITLES;
	schema = SCHEMA_TYPE;
	selectedCards: Array<any>;
	@Input() photos: Array<any>;
	@Input() isSorted: boolean;
	@Input() removedSelection: boolean;
	@Input() ruleType: string;
	@Input() cardType: string;
	@Input() SchemaType: string;
	@Output() getPhotoCardContent: EventEmitter<any> = new EventEmitter<any>();
	@ViewChildren('cardElement') cards: QueryList<ElementRef> | undefined;
	constructor(
		private broadcastService: BroadcastService,
		private photoUtils: PhotoUtilsService,
		private renderer: Renderer2
	) {
		this.selectedCards = [];
	}
	/**
	 * get related info from the photo card
	 * @param item
	 */
	setPhotoInfo(item: any): void {
		this.getPhotoCardContent.emit(item);
	}

	/**
	 * get slected car element and data
	 * @param el element selected
	 */
	selectedCard(el: any, pos: number, item: any): void {
		if (this.photoCardState.ALL === this.cardType && this.SchemaType === this.schema.INSPECTION_R) {
			this.cards.forEach((d, i) => {
				if (i === pos) {
					const { photoRefJsonPath } = item;
					if (d.nativeElement.classList.contains(this.cardUIState.SELECTED_CAR)) {
						this.renderer.removeClass(el, this.cardUIState.SELECTED_CAR);
						this.getPhotoCardContent.emit({
							path: photoRefJsonPath,
							removed: true
						});
					} else {
						this.renderer.addClass(el, this.cardUIState.SELECTED_CAR);
						this.selectedCards.push(el);
						this.getPhotoCardContent.emit({
							path: photoRefJsonPath,
							removed: false
						});
					}
				}
			});
		}
	}

	/**
	 * Listener for when a rule is created
	 */
	private onCreatedRuleListener(): void {
		this.broadcastService.on(CREATED_RULE_EVENT, (broadcast: BroadcastEventModel) => {
			this.selectedCards.forEach(card =>
				this.renderer.removeClass(card, this.cardUIState.SELECTED_CAR)
			);
			this.selectedCards = [];
		});
	}

	ngOnChanges(): void {
		if (this.photos && this.SchemaType === this.schema.INSPECTION_R) {
			this.photosCollection = this.photoUtils.setGalleryPhotosInfo(this.photos)
		}
		if (this.removedSelection && this.selectedCards.length) {
			this.selectedCards.forEach(e => this.renderer.removeClass(e, this.cardUIState.SELECTED_CAR));
			this.selectedCards = [];
		}

		if (this.photos && this.SchemaType !== this.schema.INSPECTION_R) {
			this.photosCollection = this.photoUtils.MapCVReviewInfo(this.photos)
		}

		this.photosCollection.forEach(photoCollection => {
			photoCollection.path.map((p: any) => p.thumb = p.medium)
		});
	}
	ngOnInit(): void {
		const height = this.cardType === this.photoCardState.SKETCH ? '270px' : '225px';
		this.galleryOptions.size = {
			width: '100%',
			height: height
		};

		this.onCreatedRuleListener();
	}
}
